import { motion } from 'framer-motion';

const CTA = () => {
  return (
    <section className="md:-mt-24 px-4 py-20 bg-gradient-to-r from-green-600 to-emerald-600 sm:px-6 lg:px-8">
    <div className="mx-auto max-w-4xl text-center">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">
          Ready to Secure Your Journey?
        </h2>
        <p className="mb-8 text-xl text-green-100">
          Join thousands of travelers who trust TripSecure for their protection needs
        </p>
        <motion.button
          className="px-8 py-4 font-semibold text-green-600 bg-white rounded-lg shadow-lg transition-all duration-300 hover:bg-gray-100 hover:shadow-xl"
          whileHover={{ scale: 1.05, y: -2 }}
          whileTap={{ scale: 0.95 }}
        >
          Start Your Journey
        </motion.button>
      </motion.div>
    </div>
  </section>    )
}

export default CTA